import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Helper function to determine if a URL is a video
const isVideo = (src) => {
  if (!src) return false;
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
  return videoExtensions.some(ext => src.toLowerCase().includes(ext));
};

// Styled components for images
const StyledImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

// Styled components for videos
const StyledVideo = styled(motion.video)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

// Main Media component that renders either image or video
const Media = ({ 
  src, 
  alt, 
  autoPlay = true, 
  loop = true, 
  muted = true, 
  playsInline = true,
  controls = false,
  ...props 
}) => {
  if (isVideo(src)) {
    return (
      <StyledVideo
        src={src}
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline={playsInline}
        controls={controls}
        aria-label={alt}
        {...props}
      />
    );
  }

  return (
    <StyledImage
      src={src}
      alt={alt}
      {...props}
    />
  );
};

export default Media;
export { isVideo };